import React, { FC, useEffect } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import { createSelector } from 'reselect';
import { fetchUser, setCurrentTheme } from '../../redux/actions';
import { User, UserFetchState } from '../../redux/prop-types';
import {
  isSignedInSelector,
  userFetchStateSelector,
  userSelector
} from '../../redux/selectors';
import Footer from '../Footer';
import Header from '../Header';

interface CertificationProps {
  children?: React.ReactNode;
  fetchUser: () => void;
  isSignedIn?: boolean;
  user: User;
  fetchState: UserFetchState;
}

const mapStateToProps = createSelector(
  isSignedInSelector,
  userSelector,
  userFetchStateSelector,
  (isSignedIn: boolean, user: User, fetchState: UserFetchState) => ({
    isSignedIn,
    user,
    fetchState
  })
);

const mapDispatchToProps = { fetchUser, setCurrentTheme };

const CertificationLayout: FC<
  CertificationProps & typeof mapDispatchToProps
> = props => {
  const { children, user, fetchState } = props;

  useEffect(() => {
    const { isSignedIn, fetchUser } = props;
    if (!isSignedIn) {
      fetchUser();
    }
  }, [props]);

  return (
    <>
      <Helmet />
      <Header fetchState={fetchState} user={user} />
      {children}
      <Footer />
    </>
  );
};

CertificationLayout.displayName = 'CertificationLayout';

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CertificationLayout);
